import React from 'react'
import { useSelector } from 'react-redux'
import { StyleService, useStyleSheet } from '@src/style/service'
import { Feature, InlineAlert, useFeatureFlag } from '@components'
import { Text } from '@components/base'
import { EhrAppointmentStateKind, UiInlineAlert } from '@src/types'
import { useActiveVideoSubscription } from '@src/hooks/useActiveVideoSubscription.ts'
import { getOrdinalNumber } from '@utils/number.ts'
import { usePaidCallCreditCount } from '@src/hooks/usePaidCallCreditCount.ts'
import { useVideoCallProductType } from '@src/hooks/useVideoCallProductType.ts'
import { pastEhrAppointmentsSelector } from '../../models/nutritionistHub.selectors'

export const HealthCoachingCreditDetails = () => {
  const styles = useStyleSheet(themedStyles)
  const videoCallCreditsEnabled = useFeatureFlag(Feature.VideoCallCredits)
  const { isHealthCoachingVideoCallProductType } = useVideoCallProductType()

  const { videoCallSubscription } = useActiveVideoSubscription()
  const paidCallCreditCount = usePaidCallCreditCount()
  const pastAppointments = useSelector(pastEhrAppointmentsSelector)
  const pastAppointmentsCount = pastAppointments.filter((appointment) => {
    return (
      [EhrAppointmentStateKind.NoShow, EhrAppointmentStateKind.Occurred].includes(
        appointment.lastState.kind,
      ) && appointment.meetingAt >= videoCallSubscription?.currentPeriodStartAt
    )
  }).length

  if (!videoCallCreditsEnabled || !isHealthCoachingVideoCallProductType) {
    return null
  }

  return (
    <>
      <InlineAlert
        category={UiInlineAlert.Info}
        style={styles.container}
        message={`This is your ${getOrdinalNumber(
          pastAppointmentsCount + 1,
        )} video call this month. You have ${paidCallCreditCount - 1} remaining this month.`}
      />
      <Text type="small">
        You can cancel or reschedule up to 24 hours in advance. Late changes or no-shows will use a
        call credit.
      </Text>
    </>
  )
}

const themedStyles = StyleService.create({
  container: {
    marginTop: 24,
    marginBottom: 12,
  },
})
